import React, { useState } from "react";
import { Container, Row, Col, Dropdown, Button, ProgressBar } from "react-bootstrap";
import { FaStar } from "react-icons/fa";

const CustomerReview = ({ rating_5, rating_4, rating_3, rating_2, rating_1 }) => {
  const [sortOption, setSortOption] = useState("Photo priority");
  const reviews = [
    { rating: 5, count: rating_5 },
    { rating: 4, count: rating_4 },
    { rating: 3, count: rating_3 },
    { rating: 2, count: rating_2 },
    { rating: 1, count: rating_1 },
  ];

  let getVariant = (rating) => {
    if (process.env.NODE_ENV === 'development') {
      console.log("rattttttt+++++", rating);
    }

    if (rating >= 5) return "excelent";
    if (rating >= 4) return "good";
    if (rating >= 3) return "ok";
    if (rating >= 2) return "average";
    if (rating >= 1) return "poor";
    return null;
  };

  return (
    <Container className="mt-4">
      <h2>Customer Reviews</h2>
      <Row>
        <Col md={2} className="text-center">
          <h2>{reviews.reduce((total, review) => total + review.count, 0)}</h2>
          <div className="text-warning">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} />
            ))}
          </div>
          <p>{reviews.reduce((total, review) => total + review.count, 0)} reviews</p>
        </Col>
        <Col md={2}>
          {reviews.map((review) => (
            <div key={review.rating} className="d-flex align-items-center">
              <span>{review.rating} Star</span>
              <ProgressBar
                variant={getVariant(review.rating)}
                className="mx-2"
                now={(review.count / 10) * 100}
                // now={(review.count / 156) * 100}
                style={{ width: "60%", height: "10px" }} />
              <span>{review.count}</span>
            </div>
          ))}
        </Col>
        {/* <Col md={3} className="text-end">
          <Button variant="dark" className="mb-2">Write a review</Button>
          <Dropdown>
            <Dropdown.Toggle variant="light">Sort by: {sortOption}</Dropdown.Toggle>
            <Dropdown.Menu>
              {["Photo priority", "Newest", "Highest Ratings", "Lowest Ratings"].map((option) => (
                <Dropdown.Item key={option} onClick={() => setSortOption(option)}>
                  {option}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </Col> */}
      </Row>
    </Container>
  );
};

export default CustomerReview;
